import React, { useEffect, useState } from "react";
import MainLayout from "../../layouts/main/main_layout";
import SurveyorList from "./components/surveyorList/surveyor_list";
import SurveyorLayout from "./components/layout/surveyor_layout";
import SurveyorChoicesListing from "./components/surveyor_choices_listing/surveyor_choices_listing";
import useUser from "../../providers/user/user_provider";
import { Box } from "@mui/material";
import AccessDenied from "../../components/access_denied/access_denied";
import { useSearchParams } from "react-router-dom";
import { useSurveyorsFilterStore } from "../../store/use-surveyors-filter-store";

export default function Surveyor() {
  const [searchParams, setUrlParam] = useSearchParams();
  const {currentTab}=useSurveyorsFilterStore()

  const { hasPermission } = useUser();
  function renderItemBasedOnTheTabSelection() {
    switch (currentTab) {
      case 1:
        return <SurveyorChoicesListing />;
      case 0:
        return <SurveyorList />;
      default:
        break;
    }
  }

  // useEffect(() => {
  //   setUrlParam({ currentTab:searchParams?.get("currentTab")?.toString() || '0'},{replace:true});
  // }, [currentTab]);


  return (
    <MainLayout>
      {hasPermission("surveyors", "read") ? (
        <SurveyorLayout>
          {renderItemBasedOnTheTabSelection()}
        </SurveyorLayout>
      ) : (
        <Box display="flex" flex={1} width="100%" height="100%">
          <AccessDenied />
        </Box>
      )}
    </MainLayout>
  );
}
